import AiChatModal from "components/ai_chat/AiChatModal";
import AiChatPanel from "components/ai_chat/AiChatPanel";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ContentLibraryAiChatModal({ isOpen, onClose }: Props) {
  return (
    <AiChatModal isOpen={isOpen} onClose={onClose}>
      <AiChatPanel
        resourceName="Content Library"
        resourceType="CONTENT_LIBRARY_QA"
        uiText={{
          title: "Ask Stotles AI about your content library",
          subtitle:
            "Hello, I'm Stotles AI assistant trained on all your reference materials. \nAsk me anything.",
          inputPlaceholder: "Ask about your content library",
        }}
        suggestedQuestions={[
          {
            prompt: "Do we have any case studies on delivery?",
          },
          {
            prompt: "Pull evidence for Agile portfolio management",
          },
          {
            prompt: "High scoring response on technical integration",
          },
          {
            prompt: "Pull evidence for programme delivery",
          },
        ]}
      />
    </AiChatModal>
  );
}
